import React, { useEffect, useState } from "react";

import FilterCollapseWrapper from "@src/features/table_filtering/components/filter_collapse_wrapper/filter_collapse_wrapper";
import { SearchInput } from "@src/features/table_filtering/components/search_input";
import { TreeNode } from "@src/types/antd_types";
import { Tree } from "antd";
import _ from "lodash";

interface SelectionFilterProps {
  isDataStatic?: boolean;
  title: string;
  disabled?: boolean;
  defaultKeys?: string[];
  treeData: TreeNode[];
  onFilter: (values: string[]) => void;
  customRenderer?: (node: TreeNode) => React.ReactNode;
}

const SelectionFilter: React.FC<SelectionFilterProps> = ({
  title,
  disabled = false,
  defaultKeys,
  treeData,
  onFilter,
  customRenderer,
  isDataStatic = false,
}) => {
  const [checkedKeys, setCheckedKeys] = useState<string[]>(defaultKeys);
  const [searchValue, setSearchValue] = useState<string>("");

  useEffect(() => {
    if (defaultKeys?.length > 0) {
      setCheckedKeys(defaultKeys);
    } else {
      setCheckedKeys([]);
    }
  }, [defaultKeys]);

  function handleSelection(values: string[]) {
    setCheckedKeys(values);
    onFilter(values);
  }

  function enhanceTreeData(treeData: TreeNode[]): TreeNode[] {
    return treeData.map((node) => ({
      ...node,
      title: customRenderer ? customRenderer(node) : node.title,
      children: node.children ? enhanceTreeData(node.children) : [],
    }));
  }

  const enhancedTreeData = enhanceTreeData(
    _.cloneDeep(treeData?.filter((node: TreeNode) => node.key.toLowerCase().includes(searchValue.toLowerCase())))
  );
  const enableSearch = treeData.length > 8;

  return (
    <FilterCollapseWrapper
      isDataStatic={isDataStatic}
      title={title}
      search={
        enableSearch && <SearchInput size="small" defaultValue={searchValue} onChange={setSearchValue} title={title} />
      }
    >
      {treeData.length > 0 ? (
        <Tree
          checkable
          defaultExpandAll
          disabled={disabled}
          onCheck={handleSelection}
          treeData={enhancedTreeData}
          checkedKeys={checkedKeys || []}
          selectable={false}
          data-testid="selection-filter-tree"
        />
      ) : (
        <label>No data to filter</label>
      )}
    </FilterCollapseWrapper>
  );
};

export default SelectionFilter;
